import { render, staticRenderFns } from "./VrpTabs.vue?vue&type=template&id=cf7e8f08&scoped=true&"
import script from "./VrpTabs.vue?vue&type=script&lang=js&"
export * from "./VrpTabs.vue?vue&type=script&lang=js&"
import style0 from "./VrpTabs.vue?vue&type=style&index=0&id=cf7e8f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7e8f08",
  null
  
)

export default component.exports